import connect from './connect';
import EditorPage from './EditorPage';

export default connect(EditorPage);
